import title from './title';

export default dsf.component({
  name: 'DsfTitle1',
  mixins: [title],
  ctrlCaption: "标题1",
  props: {
    value: {
      type: [String, Number],
      default: '标题1'
    },
    fontType: {
      type: Number,
      default: 1
    }
  }
});